module.exports = __webpack_public_path__ + "img/status5.db977343.png";